// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import './main.less'
import store from './store'
import 'jquery'
import { NavBar } from '@nutui/nutui';
import bootstrap from './bootstrap'
import {getUser} from './utils/getUser'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

Vue.config.productionTip = false
Vue.use(MintUI)
NavBar.install(Vue);


bootstrap({router, store})
getUser().then(()=>{
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
})


// })

// router.beforeEach((to, from, next) => { // 在main.js处添加导航首位
//   console.log(to)
//    if(to.path ==='/login'){
//     next()
//   }
//     else  {
//       if(!localStorage.getItem('islogin') ){
//       next('/login')
     
//     }else{
//     next()
//     }

//     }
 
// })




// WEBPACK FOOTER //
// ./src/main.js